module.exports = __webpack_public_path__ + "static/media/hikariGo.6c810f7a.png";